import React from 'react';
import error from './assets/error.svg';
import './AppErrormessage.css';
const AppErrorMessage = () => (React.createElement("div", { className: 'AppErrorMessage--root' },
    React.createElement("div", { className: 'AppErrorMessage--bubble' },
        React.createElement("img", { className: 'AppErrorMessage--logo', src: error, alt: 'An error occurred' })),
    React.createElement("p", { style: { textAlign: 'center', fontFamily: 'Poppins' } },
        React.createElement("strong", null, "Oops..."),
        " an error occurred.",
        React.createElement("br", null),
        "Try reloading in few seconds.")));
export default AppErrorMessage;
